import toast from "react-hot-toast";

import { AppDialog } from "../../../components/ui";
import { PointReward, formatPendingRedemptionsNotice } from "../../../models/pointReward";
import { useDeactivatePointRewardMutation } from "../../../store/services/point-rewards";
import { getApiErrorMessage } from "../../../utils/functions/api-errors";

interface DeactivatePointRewardDialogProps {
  /** Premio a dar de baja. null = modal cerrado. */
  reward: PointReward | null;
  onHide: () => void;
}

/**
 * Baja lógica de un premio. Desactivar no cancela los canjes ya generados: los QR
 * pendientes siguen válidos hasta vencer, por eso se avisa cuántos hay antes de confirmar.
 */
export const DeactivatePointRewardDialog = ({ reward, onHide }: DeactivatePointRewardDialogProps) => {
  const [deactivatePointReward, { isLoading }] = useDeactivatePointRewardMutation();

  const handleConfirm = async () => {
    if (!reward) return;
    try {
      await deactivatePointReward(reward.id).unwrap();
      toast.success("Premio desactivado.");
      onHide();
    } catch (error) {
      toast.error(getApiErrorMessage(error) ?? "No se pudo desactivar el premio");
    }
  };

  return (
    <AppDialog
      variant="destructive"
      visible={reward !== null}
      onHide={onHide}
      header="Desactivar premio"
      primaryLabel="Desactivar premio"
      onPrimary={() => void handleConfirm()}
      loading={isLoading}
    >
      {reward && (
        <>
          <p className="m-0">{`"${reward.title}" deja de mostrarse en el catálogo.`}</p>
          {reward.pendingRedemptionCount > 0 && (
            <p className="m-0 mt-3">{formatPendingRedemptionsNotice(reward.pendingRedemptionCount)}</p>
          )}
        </>
      )}
    </AppDialog>
  );
};
